'use client'

import { lightTheme, ReservoirKitProvider } from '@reservoir0x/reservoir-kit-ui'
import { RESERVOIR_CLIENT_OPTIONS } from '@utils/reservoir'
import React from 'react'

export function ReservoirProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const theme = lightTheme({
    font: 'var(--font-founders)',
    buttonFont: 'var(--font-founders)',
    headlineFont: 'var(--font-founders)',

    // Color tokens
    buttonTextColor: 'rgb(var(--on-primary))',
    buttonTextHoverColor: 'rgb(var(--on-primary))',
    primaryColor: 'rgb(var(--primary))',
    primaryHoverColor: 'rgba(var(--primary-80))',
    wellBackground: 'rgb(var(--surface-container))',
    textColor: 'rgb(var(--on-surface))',
    headerBackground: 'rgb(var(--surface))',
    contentBackground: 'rgb(var(--surface))',
    footerBackground: 'rgb(var(--surface))',
    overlayBackground: 'rgba(var(--surface-90))',
    popoverBackground: 'rgb(var(--surface))',
    borderColor: 'rgb(var(--outline-variant))'
  })
  return (
    <ReservoirKitProvider
      options={RESERVOIR_CLIENT_OPTIONS}
      theme={{ ...theme, colors: { ...theme.colors, inputBackground: 'rgb(var(--surface-container))' } }}
    >
      {children}
    </ReservoirKitProvider>
  )
}
